// extracted by mini-css-extract-plugin
module.exports = {"SuperchargeSolarStatusC":"SuperchargeSolarStatusC_SuperchargeSolarStatusC__Rjs4Z","ef-box":"SuperchargeSolarStatusC_ef-box__Pzgwm"};